import { useTranslation } from "react-i18next";
import { EmailIcon } from "../../../../components/icons";
import { PASSENGER_TITLE_OPTIONS } from "../constants";
import { Field, PhoneNumberInput, SelectInput, TextInput } from "./fields";

const TITLE_OPTIONS = PASSENGER_TITLE_OPTIONS.map((title) => ({ value: title, label: title }));

/** "Mr." dropdown next to a full-name input, as on the design. */
export const NameWithTitleField = ({ id, label, hint, title, name, errorKey, onChangeTitle, onChangeName }) => {
  const { t } = useTranslation();
  return (
    <Field id={id} label={label} hint={hint} isRequired errorKey={errorKey}>
      <div className="tw:flex tw:gap-x-[6px] tw:lg:gap-x-2">
        <SelectInput
          id={`${id}-title`}
          value={title}
          options={TITLE_OPTIONS}
          onChange={onChangeTitle}
          className="tw:!w-[90px] tw:lg:!w-[150px] tw:shrink-0"
        />
        <div className="tw:flex-1 tw:min-w-0">
          <TextInput
            id={id}
            value={name}
            errorKey={errorKey}
            placeholder={t("meetAssistInquiry.Placeholders.FullName")}
            onChange={onChangeName}
          />
        </div>
      </div>
    </Field>
  );
};

/** Email + phone, side by side on desktop. */
export const EmailAndPhoneFields = ({ idPrefix, emailLabel, phoneLabel, email, phone, emailErrorKey, phoneErrorKey, onChangeEmail, onChangePhone }) => {
  const { t } = useTranslation();
  return (
    <div className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:gap-x-[10px] tw:gap-y-[22px]">
      <Field id={`${idPrefix}-email`} label={emailLabel} isRequired errorKey={emailErrorKey}>
        <TextInput
          id={`${idPrefix}-email`}
          type="email"
          value={email}
          errorKey={emailErrorKey}
          placeholder={t("meetAssistInquiry.Placeholders.Email")}
          icon={<EmailIcon size={17} aria-hidden="true" />}
          onChange={onChangeEmail}
        />
      </Field>
      <Field id={`${idPrefix}-phone`} label={phoneLabel} isRequired errorKey={phoneErrorKey}>
        <PhoneNumberInput
          id={`${idPrefix}-phone`}
          value={phone}
          errorKey={phoneErrorKey}
          placeholder={t("meetAssistInquiry.Placeholders.Phone")}
          onChange={onChangePhone}
        />
      </Field>
    </div>
  );
};
